import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { useEffect, useState } from "react";
import "dayjs/locale/ru";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { summaryService } from "../api";
import {
  getReferences,
  getReferencesFilter,
  getThread,
  getThreadFull,
} from "../redux/selectors";
import { useNavigate } from "react-router-dom";

type Props = {
  tonal: any;
};

const TonalStatistic: any = ({ tonal }: Props) => {
  const feedFilter = useSelector(getFeedFilter);
  const thread = useSelector(getThread);
  const threadFull = useSelector(getThreadFull);
  const referencesFilter = useSelector(getReferencesFilter);
  const references = useSelector(getReferences);
  const [open, setOpen] = useState(false);
  const [keys, setKeys] = useState({
    positive: 0,
    netural: 0,
    negative: 0,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("pub");
  const navigate = useNavigate();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const selectWords = () => {
    return type == "pub"
      ? ["публикация", "публикации", "публикаций"]
      : ["комментарий", "комментария", "комментариев"];
  };

  const num_word = (value: any, words: any) => {
    value = Math.abs(value) % 100;
    var num = value % 10;
    if (value > 10 && value < 20) return words[2];
    if (num > 1 && num < 5) return words[1];
    if (num == 1) return words[0];
    return words[2];
  };

  const calcPr = (num: number) => {
    return keys?.total > 0 ? ((num * 100) / keys?.total).toFixed(1) : 0;
  };

  useEffect(() => {
    if (thread) {
      let params = {
        thread_id: window.location.pathname.includes("full")
          ? threadFull
          : +thread?.id,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        referenceFilter: window.location.pathname.includes("full")
          ? []
          : window.location.pathname.includes("thread")
          ? references
          : referencesFilter,
      };
      setLoading(true);
      type == "pub"
        ? summaryService
            .loadTrustDailyPosts(params)
            .then((resp) => {
              let data: any = {};
              for (let key in resp.total) {
                let result = resp.total[key].reduce(function (
                  sum: any,
                  current: any
                ) {
                  return sum + current[1];
                },
                0);
                data[key] = result;
              }
              setKeys(data);
              setLoading(false);
            })
            .catch((error) => {
              console.log(error);
            })
        : summaryService
            .loadTrustDailyComments(params)
            .then((resp) => {
              let data: any = {};
              for (let key in resp.total) {
                let result = resp.total[key].reduce(function (
                  sum: any,
                  current: any
                ) {
                  return sum + current[1];
                },
                0);
                data[key] = result;
              }
              setKeys(data);
              setLoading(false);
            })
            .catch((error) => {
              console.log(error);
            });
    }
  }, [thread, type, referencesFilter, feedFilter, references, tonal]);

  const changeTonal = (tonal: any) => {
    !window.location.pathname.includes("thread")
      ? navigate(
          `/thread?tonal=${tonal}&from=${
            feedFilter.from.slice(0, 10) + " 00:00:00"
          }&to=${feedFilter.to.slice(0, 10) + " 23:59:59"}`
        )
      : navigate(`/thread`);
  };

  return (
    <div
      className={
        window.location.pathname.includes("thread") ? "white-block" : ""
      }
    >
      <div className="flex-space">
        <div>
          <p className="block-title">
            Статистика тональности{" "}
            <InfoCircleOutlined className="info" onClick={showDrawer} />
          </p>
        </div>
      </div>
      {loading ? (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      ) : (
        <div
          className={
            window.location.pathname.includes("thread")
              ? "grid3"
              : "main-tonal-block"
          }
        >
          <div className="grid-block green-bg" onClick={() => changeTonal(1)}>
            <div className={"flex-end"}>
              <div>
                <p className="block-title">Позитив</p>
                <p className="grey">
                  {keys?.positive.toLocaleString()}{" "}
                  {num_word(keys?.positive, selectWords())}
                </p>
              </div>
              <div className="green title-big"> {calcPr(keys?.positive)} %</div>
            </div>
          </div>
          <div className="grid-block gray-block" onClick={() => changeTonal(0)}>
            <div className={"flex-end"}>
              <div>
                <p className="block-title">Нейтрально</p>
                <p className="grey">
                  {keys?.netural.toLocaleString()}{" "}
                  {num_word(keys?.netural, selectWords())}
                </p>
              </div>
              <div className="title-big"> {calcPr(keys?.netural)} %</div>
            </div>
          </div>
          <div className="grid-block red-bg" onClick={() => changeTonal(-1)}>
            <div className={"flex-end"}>
              <div>
                <p className="block-title">Негатив</p>
                <p className="grey">
                  {keys?.negative.toLocaleString()}{" "}
                  {num_word(keys?.negative, selectWords())}
                </p>
              </div>
              <div className="red title-big"> {calcPr(keys?.negative)} %</div>
            </div>
          </div>
        </div>
      )}
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          Статистика тональности отображает процентное соотношение позитивных,
          негативных и нейтральных упоминаний компании за выбранный период
          времени
        </p>
        <p className="title-small">Как интерпретировать данные</p>
        <ol>
          <li>
            Формула: (N позитивных сообщений/ N сообщений всего) *100 — (N
            негативных сообщений/ N сообщений всего) *100
          </li>
          <li>
            Временные интервалы: Вы можете выбрать различные временные интервалы
            для анализа динамики.
          </li>
        </ol>
        <p className="title-small">Источники данных</p>
        <ul>
          <li>Telegram</li>
          <li>Вконтакте</li>
          <li>Одноклассники</li>
          <li>Youtube</li>
          <li>Дзен</li>
        </ul>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default TonalStatistic;
